<template>
  <div class="registration-form-wrapper">
    <div class="header">
      <p>{{ `ข้อมูลเพิ่มเติม` }}</p>
      <div
        class="arrow-wrapper"
        @click="showRegistrationForm = !showRegistrationForm"
      >
        <i v-if="isShowRegistrationForm" class="arrow down"></i>
        <i v-if="!isShowRegistrationForm" class="arrow up"></i>
      </div>
    </div>
    <div v-if="isShowRegistrationForm" class="content">
      <p>{{ form.title }}</p>
      <div v-for="extra in form.extras" :key="extra.key" class="form">
        <p class="title">{{ extra.label }}</p>
        <div class="extra">
          <div v-for="input in extra.inputs" :key="input.key" class="item">
            <p class="title">{{ `${input.label} :` }}</p>
            <p v-if="input.isText" class="value">{{ input.value }}</p>
            <img
              v-else
              :src="input.value"
              @click="handleShowImage(input.value)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    registrationForm: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      showRegistrationForm: true,
    }
  },
  computed: {
    isShowRegistrationForm() {
      return this.showRegistrationForm
    },
    form() {
      const form = this.registrationForm
      const { title } = form

      return {
        title,
        extras: this.extras,
      }
    },
    extras() {
      return this.registrationForm.sections.map(({ title, inputs }) => {
        const label = title
        const key = title

        return {
          key,
          label,
          inputs: inputs.map((input) => {
            const isImage = input.type === "CITIZEN_CARD_IMAGE"
            const isText = !isImage

            return {
              key: input.title,
              label: input.title,
              value: input.value || "-",
              isImage,
              isText,
            }
          }),
        }
      })
    },
  },
  methods: {
    handleShowImage(image) {
      window.open(image, "_blank")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.registration-form-wrapper {
  display: flex;
  flex-direction: column;
  height: auto;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background-color: $white;
  overflow: hidden;

  > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px 8px 24px;

    > .arrow-wrapper {
      padding: 4px 12px;
      text-align: center;
      cursor: pointer;

      > .arrow {
        width: 8px;
        height: 8px;
        border: solid $black;
        border-width: 0 2px 2px 0;
        display: inline-block;
      }

      > .up {
        transform: rotate(-135deg);
        -webkit-transform: rotate(-135deg);
      }

      > .down {
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }
    }

    p {
      color: $black;
      font-size: 18px;
      font-weight: bold;
      flex-grow: 1;
    }
  }

  > .content {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
    padding: 16px 24px;
    border-top: 1px solid #e6e6e6;

    > .form {
      display: flex;
      flex-direction: column;

      > .title {
        color: $black;
        font-size: $font-16;
        font-weight: bold;
      }

      > .extra {
        padding-top: 8px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 8px 16px;

        > .item {
          display: flex;
          flex-direction: column;

          > .title {
            color: #808080;
            font-size: $font-14;
          }

          > .value {
            color: $black;
            font-size: $font-16;
          }

          img {
            border: 1px solid $color-light-gray-1;
            border-radius: 4px;
            width: 60px;
            height: 60px;
            margin-block: 8px;
          }
        }
      }
    }

    p {
      color: $black;
      font-size: $font-16;
    }
  }
}

@media (max-width: ($m-size - 1)) {
  .registration-form-wrapper {
    > .content {
      > .form {
        > .extra {
          display: flex;
          flex-direction: column;

          > .item {
            img {
              width: 50px;
              height: 50px;
            }
          }
        }
      }
    }
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .registration-form-wrapper {
    > .header {
      padding: 8px 16px;
    }

    > .content {
      padding: 16px;

      > .form {
        > .extra {
          display: flex;
          flex-direction: column;

          > .item {
            img {
              width: 50px;
              height: 50px;
            }
          }
        }
      }
    }
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .registration-form-wrapper {
    > .header {
      padding: 8px 16px;

      p {
        font-size: 16px;
      }
    }

    > .content {
      padding: 16px;

      > .form {
        > .title {
          font-size: $font-14;
        }

        > .extra {
          display: flex;
          flex-direction: column;

          > .item {
            > .title {
              font-size: $font-12;
            }

            > .value {
              font-size: $font-14;
            }

            img {
              width: 50px;
              height: 50px;
            }
          }
        }
      }

      p {
        font-size: $font-14;
      }
    }
  }
}
</style>
